/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190902 by Jan Brunner
 *     all rights reserved.
 */

import { Injectable } from '@angular/core';
import { ProcessStep } from 'src/app/_model/process-step';
import { KeyValuePersistenceService } from 'src/app/_services/persistence/key-value-persistence/key-value-persistence.service';
import { ProcessStepsDaoService } from '../process-steps-dao.service';

// CONSTANTS
const PROCESSSTEPS_KEY = 'process-types';

@Injectable()
export class ProcessStepsStorageDaoService implements ProcessStepsDaoService {
  constructor(private keyValueStorage: KeyValuePersistenceService) {}

  public saveProcessSteps(processSteps: ProcessStep[]): Promise<void> {
    return this.keyValueStorage.store(PROCESSSTEPS_KEY, processSteps);
  }
  public getProcessSteps(): Promise<ProcessStep[]> {
    return this.keyValueStorage.load(PROCESSSTEPS_KEY);
  }

  public async reset() {}

  public async clear() {
    await this.keyValueStorage.delete(PROCESSSTEPS_KEY);
  }
}
